<template>
    <b-modal id="login-modal" modal-class="text-center" size="sm" centered title="Login" ref="login-modal" @ok="submit" @show="resetModal" ok-title="Login">
        <loading :active="request.status == 1"></loading>
        <div>
            <div :class="'alert alert-' + this.notification.type" id="message" v-if="this.notification.message" role="alert">
                {{ this.notification.message }}
            </div>
            <b-input-group class="mb-3">
                <b-input-group-prepend is-text class="item-header-text">
                    <span>Email</span>
                </b-input-group-prepend>
                <b-input v-model="form.email" v-on:input="$v.form.email.$touch()" :state="$v.form.email.$dirty ? !$v.form.email.$error : null" type="text" class="form-control" placeholder="youremail@something.com" v-on:keyup.enter="submit"/>
                <div class="invalid-feedback d-block" v-if="$v.form.email.$invalid && validation && validation.email">
                    {{ validation.email[0] }}
                </div>
            </b-input-group>
            <b-input-group class="mb-3">
                <b-input-group-prepend is-text class="item-header-text">
                    <span>Password</span>
                </b-input-group-prepend>
                <b-input v-model="form.password" v-on:input="$v.form.password.$touch()" :state="$v.form.password.$dirty ? !$v.form.password.$error : null" type="password" class="form-control" placeholder="********" v-on:keyup.enter="submit"/>
                <div class="invalid-feedback d-block" v-if="$v.form.password.$invalid && validation && validation.password">
                    {{ validation.password[0] }}
                </div>
            </b-input-group>
            <b-row>
                <b-col cols="6" class="text-left p-0">
                    <b-button variant="link" class="px-0" @click="$router.push({ name: 'Register' })">
                        Register
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6" class="text-left p-0">
                    <b-button variant="link" class="px-0" @click="$router.push({ name: 'ForgotPassword' })">
                        Forgot password
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>

<script>
import { required, email } from 'validators'
import AuthAPI from '../../../../api/auth.js'

export default {
    name: 'LoginModal',
    data () {
        return {
            form: {
                email: '',
                password: '',
            },
            notification: {
                type: 'danger',
                message: ''
            },
            validation: null,
            request: {
                status: 0
            },
        }
    },
    validations () {
        return {
            form: {
                email: { required, email },
                password: { required },
            },
        }
    },
    methods: {
        resetModal() {
            this.validation = null
            this.notification = {
                type: 'danger',
                message: ''
            }
            this.$v.$reset()
            this.form = {
                email: '',
                password: ''
            }
        },
        goToHome() {
            this.$router.push({ name: 'Home' })
        },
        submit (bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()

            // Validation
            this.$v.$touch()
            this.login(this.form.email, this.form.password)
        },

        login (email, password) {
            var vm = this;
            // Mark request status as loading
            vm.request.status = 1
            // Do the login
            var credential = {}
            credential.email = email
            credential.password = password
            vm.$store.dispatch('user/login', credential)
            .then(res => {
                // Mark request status as loaded succesully
                vm.request.status = 2
                // Hide the modal
                vm.$refs["login-modal"].hide()
            })
            .catch(error => {
                // Mark request status as failed to load
                vm.request.status = 3
                vm.notification.type = 'danger'
                if (error.response){
                    // Show message error
                    vm.notification.message = error.response.data.error ? error.response.data.error.message : error.response.data.message
                    vm.validation = error.response.data.validation
                } else {
                    vm.notification.message = "Network error"
                }
            })
        }
    },
}
</script>
